import { BulbOutlined, HeartFilled, ShareAltOutlined } from '@ant-design/icons'
import { Card } from 'antd'
import cls from 'classnames'
import React from 'react'
import { Link } from 'react-router-dom'

import { NormalTextContent, Timestamp, UserAvatar, UserHoverCard } from '@/components'
import { NotificationActionType, NotificationMessage, RequestedNotificationFragment } from '@/generated/graphql'
import { routes } from '@/routes'

import s from './notification.module.less'

export type OnClickParam = Pick<NotificationMessage, 'targetKind' | 'targetId'>

export interface NotificationProps {
  notification: RequestedNotificationFragment
  onClick: (param: OnClickParam) => void
}

export const Notification: React.FC<NotificationProps> = ({ notification, onClick }) => {
  if (!notification.message) {
    return null
  }

  const icon = (() => {
    const iconProps = {
      style: { fontSize: 32 },
    }
    switch (notification.actionType) {
      case NotificationActionType.Like:
        return <HeartFilled {...iconProps} className={cls(s.icon, s.heart)} />
      case NotificationActionType.Useful:
        return <BulbOutlined {...iconProps} className={cls(s.icon, s.useful)} />
      case NotificationActionType.Share:
        return <ShareAltOutlined {...iconProps} className={cls(s.icon, s.share)} />
      default:
        return <UserAvatar size='large' user={notification.creators[0]} />
    }
  })()

  const renderNames = () => {
    return notification.creators.map((u, i) => (
      <React.Fragment key={i}>
        {notification.creators.length >= 2 && i >= 1 ? ', ' : null}
        {u ? (
          <UserHoverCard email={u.email}>
            <Link to={routes.users.page(u.userId)}>{u.name}</Link>
          </UserHoverCard>
        ) : (
          'Agoran'
        )}
      </React.Fragment>
    ))
  }

  const message = notification.message

  const originContent = message.content

  const content = originContent && (
    <div className={s.content}>
      <NormalTextContent
        content={originContent.length > 23 ? originContent.slice(0, 20) + '...' : originContent}
        mentions={[]}
      />
    </div>
  )

  const onClickCard = () => {
    if (!message.targetKind) {
      return
    }
    if (['post', 'request', 'group', 'user'].includes(message.targetKind)) {
      onClick({
        targetKind: message.targetKind,
        targetId: message.targetId,
      })
    }
  }

  const timestamp = (
    <div className={s.timestamp}>
      <Timestamp time={notification.createdAt}></Timestamp>
    </div>
  )

  return (
    <Card
      className={cls(s.notification, { 'is-clickable': !!message.targetKind })}
      onClick={onClickCard}
      bordered={false}
    >
      <div className={s.notificationBody}>
        <div className={s.leftWrapper}>{icon}</div>
        <div>
          <div>
            {renderNames()} {message.phrase}
          </div>
          {content}
          {timestamp}
        </div>
      </div>
    </Card>
  )
}
